import {Injectable} from "@angular/core";
import {IQuickSearch} from "../interfaces/quick-search.interface";
import {SearchFilter} from "../../../shared/models/search-filter.model";
import {FilterOperator} from "@fgpp-ui/grid";

@Injectable()
export class QuickSearchService {

  private recentSearchCriteria: IQuickSearch;

  getRecentSearchCriteria(): IQuickSearch {
    return this.recentSearchCriteria;
  }

  clearRecentSearchCriteria() {
    this.recentSearchCriteria = undefined;
  }

  buildSearchCriteria(data: IQuickSearch): Array<SearchFilter> {
    this.recentSearchCriteria = data;
    const filters: SearchFilter[] = [];
    filters.push(this.buildAmountCondition(data));
    filters.push(this.buildDateCondition(data));
    filters.push(this.buildReferenceIdCondition(data));
    filters.push(this.buildFieldIdCondition(data));
    return filters.filter(f => !!f);
  }

  private buildAmountCondition(data: IQuickSearch): SearchFilter {
    if (data.amountIdField) {
      if (!Number.isNaN(data.amountMinValue) && data.amountMaxValue !== null
        && !Number.isNaN(data.amountMaxValue)) {
        return {
          columnId: data.amountIdField,
          operator: FilterOperator.BETWEEN,
          value: [(data.amountMinValue || 0).toString(),
            (data.amountMaxValue || Number.MAX_SAFE_INTEGER).toString()]
        }
      } else if (!Number.isNaN(data.amountMinValue)) {
        return {
          columnId: data.amountIdField,
          operator: FilterOperator.GREATER_THAN_OR_EQUAL,
          value: [(data.amountMinValue || 0).toString()]
        }
      }
    }
    return null;
  }

  private buildDateCondition(data: IQuickSearch): SearchFilter {
    if (data.dateRangeType && data.dateMinValue && data.dateMaxValue) {
      return {
        columnId: 'P_CREATE_DT',
        operator: FilterOperator.BETWEEN,
        value: [data.dateMinValue, data.dateMaxValue]
      }
    }
    return null;
  }

  private buildReferenceIdCondition(data: IQuickSearch): SearchFilter {
    if (data.referenceIdField && data.referenceIdValue) {
      return {
        columnId: data.referenceIdField,
        operator: this.getOperator(data.referenceIdValue),
        value: [data.referenceIdValue]
      }
    }
    return null;
  }

  private buildFieldIdCondition(data: IQuickSearch): SearchFilter {
    const columnId = data.fieldIdType === 'Z_OTHERS' ? data.otherFieldId : data.fieldIdType;
    if (columnId && data.fieldIdValue) {
      return {
        columnId,
        operator: FilterOperator.CONTAINS,
        value: [data.fieldIdValue]
      }
    }
    return null;
  }

  getOperator(value: string): FilterOperator {
    if (value.startsWith('*') && value.endsWith('*')) {
      return FilterOperator.CONTAINS;
    } else if (value.startsWith('*')) {
      return FilterOperator.ENDS_WITH;
    } else if (value.endsWith('*')) {
      return FilterOperator.STARTS_WITH;
    } else {
      return FilterOperator.EQUAL;
    }
  }
}
